var Ractive = require('ractive');
var component = module;

	component.exports ={
		onrender: function ( options ) {
		},
		data:function() {
			return { 
				Lng:SiteLng
			}
		}
 }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"",t:13}],f:[{p:[2,3,18],t:7,e:"h2",m:[{n:"class",f:"text-uppercase",t:13}],f:[{t:3,r:"Lng.Page.404.Title",p:[2,30,45]}]}," ",{p:[3,2,77],t:7,e:"p",m:[{n:"class",f:"text-danger",t:13}],f:[{t:3,r:"Lng.Page.404.Code",p:[3,25,100]}]}," ",{p:[4,2,130],t:7,e:"i",f:[{t:3,r:"Lng.Page.404.Advise",p:[4,5,133]}]}," ",{p:[5,2,165],t:7,e:"div",m:[{n:"style",f:"height: 50px;",t:13}]}," ",{p:[6,2,201],t:7,e:"a",m:[{n:"class",f:[{t:3,r:"Lng.Page.404.Back.Class",p:[6,12,211]}],t:13},{n:"href",f:"javascript:history.go(-1);",t:13}],f:[{t:3,r:"Lng.Page.404.Back.Text",p:[6,77,276]}]},"   ",{p:[7,2,323],t:7,e:"a",m:[{n:"class",f:[{t:3,r:"Lng.Page.404.Home.Class",p:[7,12,333]}],t:13},{n:"href",f:"#",t:13}],f:[{t:3,r:"Lng.Page.404.Home.Text",p:[7,52,373]}]}]}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/404.html
// module id = 27
// module chunks = 0